module.exports = __webpack_public_path__ + "static/trendMap-4d5957f683e99f465b3f06bd10353dd4.png";